import { render, staticRenderFns } from "./TableWithCountField.vue?vue&type=template&id=1b6987c1"
import script from "./TableWithCountField.vue?vue&type=script&lang=js"
export * from "./TableWithCountField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports